import React from "react";

import { validateQuantity } from "./helpers";

const ChargedTodaySection = ({ state }) => {
    const getChargedTodayAmount = ({ quantityToAdd }) => {
        const { isValid: quantityIsValid } = validateQuantity({
            quantityToAdd
        });

        if (!quantityIsValid) return "0.00";
        return state.amountToPurchase;
    };

    return (
        <div className="charged-today">
            <h4>Charged today</h4>
            <span className="total">
                <span className="currency">USD</span>
                <span className="amount">
                    $
                    {getChargedTodayAmount({
                        quantityToAdd: state.quantityToAddInput.value
                    })}
                </span>
            </span>
        </div>
    );
};

export default ChargedTodaySection;
